<template>
  <div>
    <div v-if="seznamPodRacunov.length > 0 && !loadingSeznamRacunov">
      <div class="izgled-telefon warning-mobile-only" v-if="!neplacaniVsiRacuni && prikazTabele === '1'">
        <InfoKomponentaRacuni/>
      </div>
      <div v-if="neplacaniVsiRacuni">
        <div style="padding-top: 50px"/>
      </div>
      <div style="clear: both"/>
      <div class="postavitev-vsebine">
        <p class="navadno-besedilo">
          V seznamu so prikazani izdani računi z relevantnimi datumi, zneski ter morebitne opombe plačil.
          <br/> Vse račune si lahko tudi prenesete na svoj računalnik v .pdf formatu.
        </p>
      </div>
    </div>
    <div v-if="seznamPodRacunov.length > 0 && sestevekZaIzpis > 0" style="padding-top: 20px">
      Zapadle obveznosti
      <span :style="'color: ' + (sestevekZaIzpis > 0 ? 'orangered' : 'forestgreen')">
        {{ sestevekZaIzpis }} EUR
      </span>
    </div>
    <div v-if="seznamPodRacunov.length > 0">
      <div class="postavitev-box">
        <div>
          <div v-if="prikazTabele === '1'">
            <el-table
              :data="seznamPodRacunov"
              :default-sort="{prop: 'date', order: 'ascending', prop: 'placano_izpis', order: 'ascending'}"
              :current-page='2' :page-size='1' width="100%"
              v-loading="loadingSeznamRacunov"
              style="text-align: center">
              <el-table-column label="Številka računa">
                <div class="td-name" slot-scope="{row}">
                  <a href="javascript:void(0)"
                     @click="HtmlPrikaz(row.KLJUC, row.leto, returnHTML = true)"
                     class="primarna-barva">
                    {{ row.KLJUC }}
                  </a>
                </div>
              </el-table-column>
              <el-table-column label="Znesek računa">
                <template slot-scope="scope">
                  {{ scope.row.DEBETSI + ' €' }}
                </template>
              </el-table-column>
              <el-table-column prop="DATDOKC_izpis" sortable label="Datum izdaje" width="150px"/>
              <el-table-column prop="DATVAL" sortable label="Datum valute" width="150px"/>
              <el-table-column label="Plačano" sortable width="100px">
                <template slot-scope="scope">
                  {{ scope.row.placano_izpis }}
                </template>
              </el-table-column>
              <el-table-column label="Znesek plačila">
                <template slot-scope="scope">
                  <span v-if="scope.row.KREDITSI !== null">
                    {{ scope.row.KREDITSI + ' €' }}
                  </span>
                  <span v-else>
                    Ni podatka
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="Datum plačila">
                <template slot-scope="scope">
                  <span v-if="scope.row.DATUMPPORAVNAVE !== null && scope.row.DATUMPPORAVNAVE.length > 0">
                    {{ scope.row.DATUMPPORAVNAVE }}
                  </span>
                  <span v-else>
                    Ni podatka
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="Prenos" style="float: right" align="center">
                <div slot-scope="scope">
                  <div style="height: 100%;" v-show="scope.row.KLJUC === prenosPdfRacun">
                    Prenos v teku
                    <i class="fa fa-refresh fa-spin" style="font-size:15px">
                    </i>
                  </div>
                  <a style="display: none;" href=""/>
                  <a href="javascript:void(0)" v-show="scope.row.KLJUC !== prenosPdfRacun"
                     @click="PdfPrenos(scope.row.KLJUC, scope.row.leto)" class="primarna-barva dwnldLnk"
                     style="font-weight: normal">
                    <img src="/static/img/MojT2/Dokumenti/Icon-awesome-file-download.png">
                  </a>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div v-else>
            <el-table
              width="100%"
              :default-sort="{prop: 'date', order: 'descending'}"
              :data="seznamPodRacunov">
              <el-table-column>
                <template slot-scope="props">
                  <p>
                    <span>
                      <b>
                        Številka račun:
                      </b>
                    </span>
                    {{ props.row.KLJUC }}
                  </p>
                  <p>
                    <span>
                      <b>
                        Znesek računa:
                      </b>
                    </span>
                    {{ props.row.DEBETSI }}
                  </p>
                  <p>
                    <span>
                      <b>
                        Plačano:
                      </b>
                    </span>
                    {{ props.row.placano_izpis }}
                  </p>
                  <p>
                    <span>
                      <b>
                        Datum izdaje:
                      </b>
                    </span>
                    {{ props.row.DATDOKC_izpis }}
                  </p>
                  <p>
                    <span>
                      <b>
                        Datum valute:
                      </b>
                    </span>
                    {{ props.row.DATVAL }}
                  </p>
                  <p>
                    <span>
                      <b>
                        Datum plačila:
                      </b>
                    </span>
                    <template v-if="props.row.DATUMPPORAVNAVE !== null && props.row.DATUMPPORAVNAVE.length > 0">
                      {{ props.row.DATUMPPORAVNAVE }}
                    </template>
                    <template v-else>
                      Ni podatka
                    </template>
                  </p>
                  <p>
                    <span>
                      <b>
                        Znesek plačila:
                      </b>
                    </span>
                    <template v-if="props.row.KREDITSI !== null">
                      {{ props.row.KREDITSI + ' €' }}
                    </template>
                    <template v-else>
                      Ni podatka
                    </template>
                  </p>
                  <p class="right-position-info postavitev-mobile">
                    <span style="height: 100%;" v-show="props.row.KLJUC === prenosPdfRacun">
                      Prenos v teku
                      <i class="fa fa-refresh fa-spin" style="font-size:15px">
                      </i>
                    </span>
                    <a style="display: none;" href=""/>
                    <a href="javascript:void(0)" v-show="props.row.KLJUC !== prenosPdfRacun"
                       @click="PdfPrenos(props.row.KLJUC, props.row.leto)" class="primarna-barva dwnldLnk"
                       style="font-weight: normal">
                      <b style="height: 100%;" v-show="props.row.KLJUC !== prenosPdfRacun">
                        Prenos
                      </b>
                      <img src="/static/img/MojT2/Dokumenti/Icon-awesome-file-download.png">
                    </a>
                  </p>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <br style="clear: both"/>
          <div class="text-center">
            <el-pagination
              :hide-on-single-page="true"
              @current-change="PrikaziStran"
              :current-page="trenutnoIzbranaStran"
              :page-size="prikazTabele === '1' ? 8 : 5"
              layout="prev, pager, next"
              :total="dolzinaSeznamaRacunov"
              small>
            </el-pagination>
          </div>
        </div>
      </div>
      <div style="clear: both" />
      <div class="odmik-30">
        <div class="izgled-telefon warning-mobile-only" v-if="!neplacaniVsiRacuni && prikazTabele === '0'">
          <InfoKomponentaRacuni/>
        </div>
        <hr class="hr-stil"/>
      </div>
      <div class="odmik-30">
        <LegendaIzdaniRacuni/>
      </div>
    </div>
    <div v-else v-loading="loadingSeznamRacunov">
      <div class="obvestilo-prazen-seznam">
        <p>
          Nimate izdanih računov za pregled.
        </p>
      </div>
    </div>
    <div>
      <div style="clear: both" />
      <div class="zgornji-odmik-pomoc">
        <div id="bottom">
          <div class="postavitev-besedila-pomoc">
            <p class="open-sans-13pt no-bold">
              <span class="desni-pomik-texta-pomoc">
                Imate vprašanje glede podatkov na računu?
              </span>
              <br />
              <a class="primarna-barva" :href="stranRazlagaRacunaUrl" target="_blank">
                Poglejte si primer in razlago.
              </a>
            </p>
          </div>
          <div class="desna-postavitev-ikone-pomoc">
            <i class="fa fa-question-circle"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Vue from 'vue'
import LegendaIzdaniRacuni from './../../../Views/MojT2/Racuni/LegendaIzdaniRacuni.vue'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import {DatePicker, Button, Select, Option, Table, TableColumn, Pagination} from 'element-ui'
import {StringConverter} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import InfoKomponentaRacuni from "./InfoKomponentaRacuni";
import {PrikazVsebine} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna'
import { jsPDF } from 'jspdf'
import moment from 'moment'
import {PrenosDatoteke} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PrenosDatoteke'

Vue.use(Pagination)
export default {
  name: 'IzdaniRacuni',
  mixins: [SirinaOkna, StringConverter, PrikazVsebine, PrenosDatoteke],
  data() {
    return {
      title: 'Pregled izdanih računov',
      clientAgent: null,
      loadingSeznamRacunov: true,
      seznamPodRacunov: [],
      mejnaSirinaTabela: 1407,
      dolzinaSeznamaRacunov: null,
      prikazTabele: '1',
      expandRowKeys: [],
      trenutnoIzbranaStran: 1,
      stranRazlagaRacunaUrl: '',
      formaOrientacija: 'left',
      mejnaSirina: 360,
      prenosPdfRacun: 0,
      seznamRacunovProp: [],
      neplacaniVsiRacuni: false,
      sestevekZaIzpis: 0
    }
  },
  components: {
    InfoKomponentaRacuni,
    'LegendaIzdaniRacuni': LegendaIzdaniRacuni,
    [Button.name]: Button,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination
  },
  mounted() {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.seznamRacunovProp = []
    this.stranRazlagaRacunaUrl = povezave.BASE_URL_RAZLAGA_RACUNA
  },
  props: {
    izbranSap: '',
    seznamRacunov: {
      type: Array,
      value: []
    },
    izbranIdStranka: null
  },
  watch: {
    seznamRacunov (val) {
      if (val.length > 0) {
        this.GetSeznamRacunov(val)
      } else {
        this.seznamRacunovProp = []
        this.seznamPodRacunov = []
        this.loadingSeznamRacunov = false
      }
    },
    orientacijaPrikazaTabele (val) {
      this.prikazTabele = val
    }
  },
  methods: {
    IzbiraVrsticeZaPrikazPodatkov(row) {
      const id = row.index
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    GetDatum (datum) {
      return moment(datum, 'DD.MM.YYYY').toDate()
    },
    GetSeznamRacunov (podatki) {
      this.seznamPodRacunov = []
      this.seznamRacunovProp = []
      this.sestevekZaIzpis = 0
      this.neplacaniVsiRacuni = false
      this.seznamRacunovProp = podatki
      let sestevekZapadlihPostavk = 0
      let racuni = null
      racuni = podatki
      let steviloNeplacanih = 0
      for (const index in racuni) {
        let upostevajDatVal = false
        let postavkaDatVal = ''
        if (!Array.isArray(racuni[index].DATVAL) && typeof racuni[index].DATVAL !== 'undefined' && racuni[index].placano_izpis === 'NE') {
          upostevajDatVal = true
          postavkaDatVal = this.GetDatum(racuni[index].DATVAL)
          steviloNeplacanih++
          let todayDate = new Date()
          if (postavkaDatVal < todayDate) {
            let zamenjavaPikeVejice =  this.VejiceVPike(racuni[index].DEBETSI)
            sestevekZapadlihPostavk = sestevekZapadlihPostavk + parseFloat(zamenjavaPikeVejice)
          }
          this.sestevekZaIzpis = sestevekZapadlihPostavk.toFixed(2)
          this.neplacaniVsiRacuni = true
        }
      }

      let tmpArray = []
      this.dolzinaSeznamaRacunov = this.seznamRacunovProp.length
      const chunk = this.prikazTabele === '1' ? 8 : 5
      for (let i = 0; i < this.dolzinaSeznamaRacunov; i += chunk) {
        tmpArray.push(this.seznamRacunovProp.slice(i, i + chunk))
      }
      this.seznamRacunovProp = tmpArray
      this.PrikaziStran(this.trenutnoIzbranaStran)
      let danasnjiDan = new Date()
      danasnjiDan.setHours(0)
      danasnjiDan.setMinutes(0)
      danasnjiDan.setSeconds(0)
    },
    PrikaziStran(stran) {
      this.trenutnoIzbranaStran = stran
      if (typeof this.seznamRacunovProp[this.trenutnoIzbranaStran - 1] !== 'undefined') {
        this.seznamPodRacunov = this.seznamRacunovProp[this.trenutnoIzbranaStran - 1]
      } else {
        this.seznamPodRacunov = this.seznamRacunovProp
      }
      for (let i = 0; i < this.seznamPodRacunov.length; i++) {
        if ('DEBET' in this.seznamPodRacunov[i]) {
          Vue.set(this.seznamPodRacunov[i], 'DEBETSI', this.PikeVVejice(this.seznamPodRacunov[i].DEBET))
        }
        if ('KREDIT' in this.seznamPodRacunov[i]) {
          if (this.seznamPodRacunov[i].KREDIT === '.0000') {
            Vue.set(this.seznamPodRacunov[i], 'KREDITSI', null)
          } else {
            Vue.set(this.seznamPodRacunov[i], 'KREDITSI', this.PikeVVejice(this.seznamPodRacunov[i].KREDIT))
          }
        }
      }
      this.loadingSeznamRacunov = false
    },
    ErrSeznamRacunov(podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.loadingSeznamRacunov = false
    },
    PdfPrenos(idRacuna, leto) {
      this.prenosPdfRacun = idRacuna
      let param = ['sap=' + this.izbranSap]
      param.push('dokument=' + idRacuna)
      param.push('leto=' + leto)
      param.push('format=pdf')
      this.clientAgent.postWsRequest(
        this,
        'stranka/racun/prikazRacuna',
        param,
        null,
        'SetPrenosPdf',
        'ErrPrenosPdf')
    },
    SetPrenosPdf(podatki) {
      let vsebinaPdf = 'data:application/pdf;base64,' + podatki.data.racun
      const fileName = 'Račun:' + podatki.data.datoteka + '.' + podatki.data.koncnica
      this.PrenesiDatoteko(vsebinaPdf, fileName)
      this.prenosPdfRacun = 0
    },
    ErrPrenosPdf(podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.prenosPdfRacun = 0
    },
    HtmlPrikaz(idRacuna, leto, returnHTML = false) {
      let popupWindow = null
      if (returnHTML !== false) {
        popupWindow = window.open('',
          'popUpWindow',
          'height=850,' +
          'width=900,' +
          'left=10,top=10,' +
          'resizable=yes,' +
          'scrollbars=yes,' +
          'toolbar=yes,' +
          'menubar=no,' +
          'location=no,' +
          'directories=no,' +
          'status=yes')
        popupWindow.document.body.innerHTML = '' +
          '<html>' +
          '<body>' +
          'Nalaganje. Prosimo počakajte...' +
          '</body>' +
          '</html>'
      }
      let param = ['sap=' + this.izbranSap]
      param.push('dokument=' + idRacuna)
      param.push('leto=' + leto)
      this.clientAgent.postWsRequest(
        this,
        '/stranka/racun/prikazRacuna',
        param,
        popupWindow,
        'SetPredogledRacuna',
        'ErrPredogledRacuna')
    },
    SetPredogledRacuna(podatki, popupWindow) {
      let racunData = atob(podatki.data.racun)
      let blob = this.base64ToBlob(racunData, 'application/pdf')
      let url = URL.createObjectURL(blob)
      popupWindow.document.write('<iframe width="100%" height="100%" src="' + url + '"></iframe>')
    },
    ErrPredogledRacuna(podatki, popupWindow) {
      popupWindow.document.body.innerHTML = 'Ni mogoče prikazati računa.'
    },
    base64ToBlob (binStr, type = 'application/octet-stream') {
      const len = binStr.length;
      const arr = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        arr[ i ] = binStr.charCodeAt( i )
      }
      return new Blob( [ arr ], { type: type } )
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/MojT-2/Racuni/IzdaniRacuni.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Racuni/IzdaniRacuni.vue